import {
  SET_LOADING_DATA,
  SET_LOADING_SEND,
  GET_ALL_REQUEST,
  GET_ALL_SUCCESS,
  GET_BY_ID_REQUEST,
  GET_BY_ID_SUCCESS,
  DELETE_OR_CANCEL_ITEM,
  EDIT_ITEM,
  SET_PAGE,
  SET_ROWS_PER_PAGE,
  SET_ORDER,
  SET_ORDERBY,
  SAVE_REQUEST,
  SAVE_SUCCESS,
  SEARCH,
  GET_ALL_FILTER_SELECTS_REQUEST,
  GET_ALL_FILTER_SELECTS_SUCCESS,
  SHARE_PDF,
  SET_LOADING_SELECTS,
  RESEND_ITEM,
  SET_LOADING_VINCULATED_ORDER,
  CANCEL_ORDER_TOTVS,
  DOWNLOAD_EXCEL,
} from './order-constants';

export const setLoadingData = (loading: Boolean) => {
  return {
    type: SET_LOADING_DATA,
    loading
  };
};

export const setLoadingSend = (loading: Boolean) => {
  return {
    type: SET_LOADING_SEND,
    loading
  };
};

export const setLoadingGetSelects = (loading: Boolean) => {
  return {
    type: SET_LOADING_SELECTS,
    loading
  };
};

export const setLoadingVinculatedOrder = (loading: Boolean) => {
  return {
    type: SET_LOADING_VINCULATED_ORDER,
    loading
  };
};

export const getAllRequest = (payload?: {
  sellersSelecteds?: any[];
  dateRange?: any;
  status?: any;
  orderNumber?: any;
  externalOrder?: any;
  orderType?: any;
  client?: any;
  invoiceNumber?: any;
  orderExternalNumber?: any;
  filiais?: any[] | string;
}) => {
  return {
    type: GET_ALL_REQUEST,
    payload
  };
};

export const getAllSuccess = (payload: any) => {
  return {
    type: GET_ALL_SUCCESS,
    payload
  };
};

export const getByIdRequest = (id: string) => {
  return {
    type: GET_BY_ID_REQUEST,
    id
  };
};

export const getByIdSuccess = (payload: any) => {
  return {
    type: GET_BY_ID_SUCCESS,
    payload
  };
};

export const saveRequest = (id: any, payload: any, files?: any) => {
  return {
    type: SAVE_REQUEST,
    id,
    payload,
    files
  };
};

export const saveSuccess = async () => {
  return {
    type: SAVE_SUCCESS
  };
};

export const deleteOrCancelOrder = ({
  id,
  isDetail,
  isBudget = false
}: {
  id: string;
  isDetail?: boolean;
  isBudget?: boolean;
}) => {
  return {
    type: DELETE_OR_CANCEL_ITEM,
    id,
    isDetail,
    isBudget
  };
};

export const editItem = (id: string) => {
  return {
    type: EDIT_ITEM,
    id
  };
};

export const resendItem = (id: string) => {
  return {
    type: RESEND_ITEM,
    id
  };
};

export const setPage = (page: Number) => {
  return {
    type: SET_PAGE,
    page
  };
};

export const setRowsPerPage = (rowsPerPage: Number) => {
  return {
    type: SET_ROWS_PER_PAGE,
    rowsPerPage
  };
};

export const setOrder = (order: String) => {
  return {
    type: SET_ORDER,
    order
  };
};

export const setOrderBy = (orderBy: String) => {
  return {
    type: SET_ORDERBY,
    orderBy
  };
};

export const getAllFiltersSelectRequest = (client?: string) => {
  return {
    type: GET_ALL_FILTER_SELECTS_REQUEST,
    client
  };
};

export const getAllFiltersSelectSuccess = (payload: any) => {
  return {
    type: GET_ALL_FILTER_SELECTS_SUCCESS,
    payload
  };
};

export const search = (queryText?: String) => {
  return {
    type: SEARCH,
    queryText
  };
};

export const sharePdf = (order: any) => {
  return {
    type: SHARE_PDF,
    order
  };
};

export const downloadExcelRequest = (order: any) => {
  return {
    type: DOWNLOAD_EXCEL,
    order
  };
};

export interface CancelOrderTotvsPayloadTypes {
  id: string;
  reasonCancellation: string;
}

export interface CancelOrderTotvsTypes {
  type: typeof CANCEL_ORDER_TOTVS;
  payload: CancelOrderTotvsPayloadTypes;
}

export const cancelOrderTotvs = ({ id, reasonCancellation }: CancelOrderTotvsPayloadTypes): CancelOrderTotvsTypes => {
  return {
    type: CANCEL_ORDER_TOTVS,
    payload: { id, reasonCancellation }
  };
};
